import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const edgescan = defineConnector({
  identifier: "edgescan",
  name: "Edgescan",
  tagLine: "Continuous vulnerability management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://live.edgescan.com/api"),
  auth: basicAuth({
    username: { from: "literal", value: "3B" },
    password: { from: "secret", field: "apiToken" },
  }),
  steps: [
    {
      title: "Set up Edgescan",
      items: [
        {
          kind: "markdown",
          content:
            "In Edgescan, open **Account settings → Authentication tokens** and create a token. Copy it before closing the dialog. Use an account with view access to the assets you need. See [Create API tokens](https://kb.edgescan.com/knowledge/creating-api-and-authentication-tokens).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://live.edgescan.com/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use https://live.edgescan.com/api. If Edgescan provides a different server URL for your account, include its /api path.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Generate an API token in Edgescan under Account settings → Authentication tokens. Store it securely because Edgescan does not display the token again.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://live.edgescan.com/api")
          .trim()
          .replace(/\/+$/, "") + "/v1/vulnerabilities.json?limit=1",
      ...{ method: "GET" },
    }),
  },
});
